import { getColor } from "./shared.js";
import { Text } from "@mantine/core";
import { jsx } from "react/jsx-runtime";

//#region src/components/typography/Body1.tsx
const Body1 = ({ children, bold = false, color = "currentColor", ta, highContrast = false, inline = false, "data-testid": testId, ellipsis = false, noWrap = false }) => /* @__PURE__ */ jsx(Text, {
	size: "md",
	component: inline ? "span" : "p",
	fw: bold ? 600 : 400,
	ta,
	style: {
		color: getColor(color, highContrast),
		...ellipsis && {
			whiteSpace: "nowrap",
			overflow: "hidden",
			textOverflow: "ellipsis"
		},
		textWrap: noWrap ? "nowrap" : "wrap"
	},
	"data-testid": testId,
	children
});

//#endregion
export { Body1 };